import { deserialize as deserializeArray, deserializeStream, deserializeFiltered } from "./generic/featurecollection.js";
/**
 * Deserialize FlatGeobuf into generic features
 * @param input Input byte array, stream or string
 * @param fromFeature Callback that recieves generic features
 * @param rect Filter rectangle
 */
export function deserialize(input, fromFeature, rect) {
    if (input instanceof Uint8Array)
        return deserializeArray(input, fromFeature);
    else if (input instanceof ReadableStream)
        return deserializeStream(input, fromFeature);
    return deserializeFiltered(input, rect, fromFeature);
}
export { serialize } from "./generic/featurecollection.js";
export { GeometryType } from "./flat-geobuf/geometry-type.js";
export { ColumnType } from "./flat-geobuf/column-type.js";
